import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Observable, of } from 'rxjs';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { gridColumnHeadingModel } from '../models/grid-column-heading-model';

import { MasterDataService } from '../services/masterdata.service';
import { SessionService } from '../services/session.service';
import { UserRolesService } from '../services/user-roles.service';
import $ from 'jquery';
declare var bootstrap: any;

import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  tap,
  switchMap,
  filter,
  mergeMap,
  pairwise,
  takeUntil,
} from 'rxjs/operators';
import { loadavg } from 'os';
import Collapse from 'bootstrap/js/dist/collapse';
@Component({
    selector: 'app-search-session',
    templateUrl: './search-session.component.html',
    styleUrls: ['./search-session.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchSessionComponent implements OnInit {
  private subscription: Subject<void> = new Subject<void>();
  private readonly sessionSearchPageName: string = 'SessionSearch';
  public masterData: any;
  public serviceFunctionList: Array<any>;
  public sessionStartDate: any;
  public sessionEndDate: any;
  public companyName: string;
  public showTable: boolean = false;
  public sessionAudienceCheckboxList: Array<any>; // for checkbox
  public sessionStatusCheckboxList: Array<any>;
  public AudienceList: any;
  public sponsoringCountryList: Array<any>;
  public sessionCountryList: Array<any>;
  public sessionStateList: Array<any>;
  public sessionTypeList: Array<any>;
  public contentAreaList: Array<any>;
  public TopicList: Array<any>;
  public sessionFormatList: Array<any>;
  public IsInternalDeloitte: boolean = false;
  public IsClient: boolean = false;
  public IsNonClient: boolean = false;
  public IsMixedAudience: boolean = false;
  public IsToReview: boolean = false;
  public IsApproved: boolean = false;
  public IsNotApproved: boolean = false;
  public IsCancelled: boolean = false;
  public IsDraft: boolean = false;
  public startDate: any;
  public endDate: any;
  public enableSearch: boolean = true;
  public totalRecords: number = 0;
  public totalNoRecords: number = 0;
  public subsIDErrorMsg: string = '';
  public sessionErrorMsg: string = '';
  public sessCoordErrorMsg: string = '';
  public facilitatorErrorMsg: string = '';
  public compNameErrorMsg: string = '';
  public isSubId: boolean = false;
  public isSessionId: boolean = false;
  public isSessCoord: boolean = false;
  public isFacilitator: boolean = false;
  public isCompName: boolean = false;
  public selectedFunction: number = 0;
  public selectedSponsoringCountry: any = null;
  public selectedSessionCountry: number = 0;
  public selectedSessionState: number = 0;
  public selectedSessionType: number = 0;
  public selectedContentArea: number = 0;
  public selectedTopic: number = 0;
  public disableContentArea: boolean = true;
  public disableTopic: boolean = true;
  public selectedSessionFormat: any = null;
  public selectedSubscriptionId: string = '';
  public selectedSessionName: string = '';
  public selectedSessionCoordinator: string = '';
  public selectedFacilitator: string = '';
  public selectedCompanyName: string = '';
  public isEnableExportBtn: boolean = false;
  public IsDateInvalid: boolean = false;
  public invalidDateErrorMsg: string = '';
  public pageSize: number = 1000;
  public SessionAudienceMapping: any;
  public sampleColumns: gridColumnHeadingModel[] = [];
  public allSampleColumns: gridColumnHeadingModel[] = [];
  public sampleData: any;
  public allowCheckbox: boolean = false;
  public iseventRegistered: boolean = false;
  public allowPagination: boolean = false;

  // if we are handling clientside pagination then "isClientSidePagination" field value will be true
  public isClientSidePagination: boolean = true;

  public enableSearchBtn: boolean = false;
  public enableClearBtn: boolean = false;

  public sessionEventList: Array<any>;
  public sessionProgramList: Array<any>;
  public sessionEventFilterList: Array<any>;
  public sessionProgramFilterList: Array<any>;
  public sessionEventSelected: any = null;
  public sessionProgramSelected: any = null;
  public showEventProgram: boolean = false;
  public showLoaderIcon: boolean = false;
  public showProgramFinance: boolean = false;
  searchGridHeight: any;
  searchAreaFields: boolean = true;
  seaerchAreaDownArrow: boolean = false;
  seaerchAreaUpArrow: boolean = false;
  isExpandSearchFields: boolean = false;
  userRoleID: number;
  public tempSessionSearchData: any;
  dropdownData: any;
  isAdvanceSearch: boolean = false;

  searching = false;
  searchFailed = false;
  temp: any[];
  tempSessionTypeList: any;
  updatedSessionTypeList: any;
  uniquesessiontypelist: any;
  HighestRoleId: any;
  isUserSuperAdmin = false;
  userRoleList: any[] = [];
  allSessionCountries: any[];
  tempSubscriptionId: string;
  public ISUSNonUs: boolean = false;
  // Column count updated - now 7 default columns instead of 5
  public selectedAdditionalColumnNames: string[] = [];
  public pinnedAdditionalColumnNames: string[] = [];
  public isColumnSelectorOpen: boolean = false;
  public readonly defaultVisibleColumnCount: number = 7;
  public loggedInUserId: number = 0;

  get defaultColumns(): gridColumnHeadingModel[] {
    return this.allSampleColumns.slice(0, this.defaultVisibleColumnCount);
  }

  get optionalColumns(): gridColumnHeadingModel[] {
    return this.allSampleColumns.slice(this.defaultVisibleColumnCount);
  }

  get roleFilteredOptionalColumns(): gridColumnHeadingModel[] {
    return this.optionalColumns.filter(
      (column) => column.name !== 'EventName' || this.userRoleID === 1
    );
  }

  get visibleColumnCountLabel(): string {
    if (this.userRoleID === 1) {
      return `${this.sampleColumns.length}/${this.allSampleColumns.length}`;
    } else {
      return `${this.sampleColumns.length}/${this.allSampleColumns.length-1}`;
    }
    
  }

  get showSubscriptionId() {
    if (!this.isUserSuperAdmin) {
      return this.userRoleList.some(
        (i) => i.roleId == 6 || this.userRoleID === 3
      );
    }
    return (
      this.userRoleID === 1 || this.userRoleID === 6 || this.userRoleID === 3
    );
  }

  constructor(
    private sessionService: SessionService,
    private masterDataService: MasterDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public userRoleService: UserRolesService,
    private cdr: ChangeDetectorRef
  ) {
    this.sessionAudienceCheckboxList = [];
    this.sessionStatusCheckboxList = [];
    this.sessionStartDate = '';
    this.sessionEndDate = '';
    this.selectedSponsoringCountry = null;
  }

  ngOnInit() {
    this.tempSessionSearchData = this.masterDataService.sessionSearchModelData;
    this.ISUSNonUs = this.userRoleService.ISUSNonUs;
    this.masterDataService
      .getMasterDataDetails()
      .pipe(takeUntil(this.subscription))
      .subscribe((masterData) => {
        if (masterData) {
          this.masterData = JSON.parse(JSON.stringify(masterData));
          this.dropdownData = JSON.parse(JSON.stringify(masterData));
          this.userRoleService.getUserRoleID().subscribe((id) => {
            this.userRoleID = Number(id);
            this.applyVisibleColumns();
            this.setDataOnLoad();
            this.setSponsringCountryBasedOnRole();
            this.setFormatAndTypeDropdown();
            this.reloadPageWithData(true); //persisting
          });
        }
      });
    this.setIsUserSuperAdmin();
    this.setColumnHeading();
    this.initializeUserSpecificColumns();
    setTimeout(() => {
      this.HighestRoleId = this.userRoleService.userRoleId;
    }, 4000);
    // This code may require in future
    // this.userRoleService.roleIdSubject.subscribe((roleId) => {
    //   this.masterDataService
    //     .getMasterDataDetails()
    //     .takeUntil(this.subscription)
    //     .subscribe((masterData) => {
    //       this.masterData = JSON.parse(JSON.stringify(masterData));
    //       this.loadSessionFormatDropDown(roleId);
    //       this.loadSessionTypeDropDown(roleId);
    //       this.setDataOnTabChange();
    //     });
    // });
  }

  initializeUserSpecificColumns() {
    const userId = Number(this.userRoleService.loggedInUserId);
    if (userId > 0) {
      this.loggedInUserId = userId;
      this.loadUserSpecificColumnSelection();
      return;
    }

    this.userRoleService
      .getLoggedInUserID()
      .pipe(takeUntil(this.subscription))
      .subscribe((id) => {
        const resolvedUserId = Number(id);
        if (resolvedUserId > 0) {
          this.loggedInUserId = resolvedUserId;
          this.loadUserSpecificColumnSelection();
        }
      });
  }

  loadUserSpecificColumnSelection() {
    if (!this.loggedInUserId) {
      return;
    }

    this.sessionService
      .getUserSpecificSearchGrid(
        String(this.loggedInUserId),
        this.sessionSearchPageName
      )
      .pipe(takeUntil(this.subscription))
      .subscribe((responseData) => {
        const savedColumns = this.getValidAdditionalColumnNames(responseData);
        this.selectedAdditionalColumnNames = savedColumns;
        this.pinnedAdditionalColumnNames = [...savedColumns];
        this.applyVisibleColumns();
        this.cdr.detectChanges();
      });
  }

  getValidAdditionalColumnNames(data: any): string[] {
    const optionalColumnSet = new Set(this.optionalColumns.map((x) => x.name));
    const parsedColumns = this.parseSavedColumns(data);
    return parsedColumns.filter((columnName) => optionalColumnSet.has(columnName));
  }

  parseSavedColumns(data: any): string[] {
    if (!data) {
      return [];
    }

    if (Array.isArray(data)) {
      return data.filter((value) => typeof value === 'string');
    }

    if (typeof data === 'string') {
      const trimmedData = data.trim();
      if (!trimmedData) {
        return [];
      }

      try {
        const parsed = JSON.parse(trimmedData);
        return this.parseSavedColumns(parsed);
      } catch {
        return trimmedData
          .replace(/[()]/g, '')
          .split(',')
          .map((value) => value.replace(/["']/g, '').trim())
          .filter((value) => value.length > 0);
      }
    }

    if (typeof data === 'object') {
      const potentialColumns =
        data.Columns ||
        data.ColumnNames ||
        data.ExtraColumns ||
        data.Data ||
        data.value;
      return this.parseSavedColumns(potentialColumns);
    }

    return [];
  }

  get canPinCurrentView(): boolean {
    // Button disabled if no logged-in user
    if (!this.loggedInUserId) {
      return false;
    }

    // Button enabled only if current selection differs from what's pinned
    const currentState = this.selectedAdditionalColumnNames.slice().sort((a, b) => a.localeCompare(b)).join('|');
    const pinnedState = this.pinnedAdditionalColumnNames.slice().sort((a, b) => a.localeCompare(b)).join('|');

    return currentState !== pinnedState;
  }

  pinCurrentView() {
    if (!this.loggedInUserId) {
      return;
    }
    this.showLoaderIcon = true;
    const payload = [...this.selectedAdditionalColumnNames];
    this.sessionService
      .saveUserSpecificSearchGrid(
        String(this.loggedInUserId),
        this.sessionSearchPageName,
        payload
      )
      .pipe(takeUntil(this.subscription))
      .subscribe(() => {
        this.pinnedAdditionalColumnNames = [...payload];
        this.cdr.detectChanges();
        this.showLoaderIcon = false;
      });
  }

  // method to check if the user has super admin role or not
  setIsUserSuperAdmin() {
    this.userRoleService.getUserRoleList().subscribe((result: any) => {
      this.userRoleList = result ? result : [];
      if (result && result.some((i) => i.roleId == 1)) {
        this.isUserSuperAdmin = true;
      }
    });
  }
  onFocusOutSubscriptionID() {
    if (this.selectedSubscriptionId) {
      if (this.selectedSubscriptionId !== this.tempSubscriptionId) {
        this.tempSubscriptionId = this.selectedSubscriptionId;
        this.sessionService
          .getSubscriptionData(this.selectedSubscriptionId)
          .subscribe((res) => {
            if (res) {
              if (
                res['SubscriptionType'] != null &&
                res['SubscriptionType'].toLowerCase() == 'commercialization'
              ) {
                this.sessionCountryList = this.sessionCountryList.filter(
                  (item) => item.ID != 259 && item.ID != 265 && item.ID != 266
                );
                this.selectedSessionCountry = 0;
                this.selectedSessionState = 0;
              } else {
                this.sessionCountryList = this.allSessionCountries;
              }
            }
          });
      }
    } else {
      this.tempSubscriptionId = this.selectedSubscriptionId;
      this.sessionCountryList = this.allSessionCountries;
    }
  }

  searchCompanies = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.sessionService.searchword(term, 0).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );

  formatMatches = (value: any) => {
    if (typeof value == 'object') {
      return value.Name;
    } else if (typeof value == 'string') {
      return value;
    } else {
      return null;
    }
  };
  onCompanySelect(companyData) {
    if (companyData && companyData.item) {
      this.selectedCompanyName = companyData.item.Name;
      this.isCompName = false;
    }
  }
  setFormatAndTypeDropdown() {
    this.seaerchAreaDownArrow = false;
    this.seaerchAreaUpArrow = true;
    //this.userRoleService.getUserRoleID().subscribe((id) => {
    //  this.userRoleID = Number(id);
      //this.masterDataService
      //  .getMasterDataDetails()
      //  .pipe(takeUntil(this.subscription))
      //  .subscribe((masterData) => {
          //this.masterData = JSON.parse(JSON.stringify(masterData));
      this.loadSessionFormatDropDown(this.userRoleID);
      this.loadSessionTypeDropDown(this.userRoleID);
        //});
    //});
  }

  setSponsringCountryBasedOnRole() {
    this.seaerchAreaDownArrow = false;
    this.seaerchAreaUpArrow = true;
    //this.userRoleService.getUserRoleID().subscribe((id) => {
    //  this.userRoleID = Number(id);

      if (this.userRoleID === 1 || this.userRoleID === 3) {
        this.loadSponsoringCountry();
      }
    //});
  }

  loadSponsoringCountry() {
    if (this.masterData && Object.keys(this.masterData).length > 0) {
      const assignedCountries = this.userRoleService.userAssignedCountries;
      this.sponsoringCountryList = JSON.parse(
        JSON.stringify(this.masterData.Countries)
      ); //
      if (assignedCountries && assignedCountries.length > 0) {
        this.sponsoringCountryList = [];
        assignedCountries.map((country, index) => {
          const countryDetail = this.masterData.Countries.filter(
            (data) => data.ID == assignedCountries[index]
          );
          if (countryDetail && countryDetail.length > 0) {
            this.sponsoringCountryList.push(countryDetail[0]);
          }
        });
      }
    }
  }

  loadSessionTypeDropDown(roleId: number) {
    this.updateSessionType();
    this.selectedSessionType = null;
    this.enableContentArea();
    this.onSessionTypeChange();
    if (roleId !== 1 && roleId !== 6 && this.selectedSubscriptionId) {
      this.enableSearchBtn = false;
      if (
        this.selectedSessionName !== '' ||
        this.selectedSessionCoordinator !== '' ||
        this.selectedFacilitator !== '' ||
        this.selectedFunction !== 0 ||
        this.selectedCompanyName !== '' ||
        this.IsInternalDeloitte !== false ||
        this.IsClient !== false ||
        this.IsNonClient !== false ||
        this.IsMixedAudience !== false ||
        this.IsCancelled !== false ||
        this.IsToReview !== false ||
        this.IsApproved !== false ||
        this.IsNotApproved !== false ||
        this.IsCancelled !== false ||
        this.IsDraft !== false ||
        this.selectedSponsoringCountry != null ||
        this.selectedSessionCountry !== 0 ||
        this.selectedSessionState !== 0 ||
        (this.selectedSessionType !== 0 && this.selectedSessionType != null) ||
        (this.selectedSessionFormat !== 0 &&
          this.selectedSessionFormat != null) ||
        (this.startDate != undefined &&
          this.startDate.year != null &&
          this.endDate != undefined &&
          this.endDate.year != null)
      ) {
        this.enableSearchBtn = true;
      }
    } else {
      if (this.selectedSubscriptionId) {
        this.enableSearchBtn = true;
      }
    }
  }

  loadSessionFormatDropDown(roleId: number) {
    this.sessionFormatList = this.masterData['SessionFormat']
      ? this.masterData['SessionFormat']
      : [];
    this.sessionFormatList = this.sessionFormatList
      ? this.getUniqueList(this.sessionFormatList, 'SessionFormatName')
      : [];
    this.selectedSessionFormat = null;
  }

  @ViewChild('headerHeight')
  headerHeight: ElementRef;
  @ViewChild('searchFieldsHeight', { static: true })
  searchFieldsHeight: ElementRef;
  @ViewChild('columnPickerContainer')
  columnPickerContainer: ElementRef;

  onResize(event) {
    if (!this.isExpandSearchFields) {
      this.searchGridHeightSet();
    } else {
      setTimeout(() => {
        var SearchFildsHeight =
          this.searchFieldsHeight.nativeElement.offsetHeight;
        const screenHeight = window.innerHeight;
        const totalDedVal = SearchFildsHeight - 100;
        return (this.searchGridHeight = screenHeight - totalDedVal + 'px');
      }, 300);
    }
  }

  searchGridHeightSet() {
    setTimeout(() => {
      var SearchFildsHeight =
        this.searchFieldsHeight.nativeElement.offsetHeight;
      const screenHeight = window.innerHeight;
      const totalDedVal = SearchFildsHeight + 230;
      return (this.searchGridHeight = screenHeight - totalDedVal + 'px');
    }, 300);
  }

  searchAreaExpand() {
    if (this.isAdvanceSearch) {
      setTimeout(() => {
        const element = document.querySelector('#accordion .accordion1');
        if (element) {
          element.classList.add('show');
          element.classList.remove('collapse');
        }
      }, 100);
    } else {
      setTimeout(() => {
        const element = document.querySelector('#accordion .accordion1');
        if (element) {
          element.classList.add('collapse');
          element.classList.remove('show');
        }
      }, 100);
    }
    this.searchAreaFields = true;
    this.seaerchAreaDownArrow = false;
    this.seaerchAreaUpArrow = true;
    this.searchGridHeight = '400px';
    this.isExpandSearchFields = true;
    this.updateSessionType();
  }

  searchAreaCollapse() {
    this.isExpandSearchFields = false;
    this.searchAreaFields = false;
    this.seaerchAreaDownArrow = true;
    this.seaerchAreaUpArrow = false;
    this.searchGridHeightSet();
  }

  setDataOnLoad() {
    this.serviceFunctionList = this.masterData['ServiceFunctions']
      ? this.masterData['ServiceFunctions'].filter(
        (data) => !data.IsMDR && data.IsActive
      )
      : [];
    this.sponsoringCountryList = this.masterData['Countries']
      ? this.masterData['Countries']
      : [];
    this.sessionCountryList = this.masterData['Countries']
      ? this.masterData['Countries'].filter(
        (country) => country.ID != 266
      )
      : [];
    this.allSessionCountries = this.masterData['Countries']
      ? this.masterData['Countries'].filter(
        (country) => country.ID != 266
      )
      : [];
    this.sessionStateList = this.masterData['States']
      ? this.masterData['States']
      : [];
    this.sessionTypeList = this.masterData['SessionType']
      ? this.masterData['SessionType']
      : [];
    this.sessionFormatList = this.masterData['SessionFormat']
      ? this.masterData['SessionFormat']
      : [];
    this.sessionEventList = this.masterData['SessionTypeEvents']
      ? this.masterData['SessionTypeEvents']
      : [];
    this.sessionProgramList = this.masterData['EventPrograms']
      ? this.masterData['EventPrograms']
      : [];
    this.uniquesessiontypelist = this.masterData['SessionType']
      ? this.masterData['SessionType']
      : [];
    this.contentAreaList = this.masterData['ContentArea']
      ? this.masterData['ContentArea']
      : [];
    this.TopicList = this.masterData['Topic']
      ? JSON.parse(JSON.stringify(this.masterData['Topic'])).sort((a, b) =>
        a.TopicName.localeCompare(b.TopicName)
      )
      : [];
  }

  setDateFormat(event) {
    if (event != null) {
      const year = event.year;
      const month = event.month <= 9 ? '0' + event.month : event.month;
      const day = event.day <= 9 ? '0' + event.day : event.day;
      const finalDate = year + '-' + month + '-' + day;

      return finalDate;
    }
    return null;
  }

  //From Date
  onStartDateSelect(event) {
    this.sessionStartDate = this.setDateFormat(event);
  }

  //To Date
  onEndDateSelect(event) {
    this.sessionEndDate = this.setDateFormat(event);
  }

  public setSessionAudienceCheckboxValue(id, isChecked) {
    
    if (isChecked) {
      this.sessionAudienceCheckboxList.push(id);
    } else {
      const index = this.sessionAudienceCheckboxList.indexOf(id);
      this.sessionAudienceCheckboxList.splice(index, 1);
    }
    if (this.sessionAudienceCheckboxList.some(id => [1, 3, 4].includes(id))) {
      // Include ID 266 in sponsoringCountryList
      this.loadSponsoringCountry();
    } else if (this.sessionAudienceCheckboxList.includes(2)) {
      // Exclude ID 266 from sponsoringCountryList
      this.sponsoringCountryList = this.masterData.Countries.filter(
        (country) => country.ID !== 266
      );
    } else {
      // Reset to the original list
      this.loadSponsoringCountry();
    }

    this.selectedSessionType = null;
    this.updateSessionType();
    this.onSessionTypeChange();
  }

  public updateSessionType() {
    this.SessionAudienceMapping = {
      1: 'Deloitte',
      2: 'ExternalClient',
      3: 'ExternalNonClient',
      4: 'MixedAudience',
    };
    this.AudienceList = this.sessionAudienceCheckboxList.map(
      (value) => this.SessionAudienceMapping[value]
    );
    this.tempSessionTypeList = [];

    if (this.AudienceList.length == 0) {
      this.tempSessionTypeList = this.masterData['SessionType']
        ? this.masterData['SessionType']
        : [];
    } else {
      this.AudienceList.forEach((audienceType) => {
        const updatedSessionTypeList = this.masterData['SessionType']
          ? this.masterData['SessionType'].filter(
            (sessionType) => sessionType.SessionAudience == audienceType
          )
          : [];
        updatedSessionTypeList.forEach((value) => {
          this.tempSessionTypeList.push(value);
        });
      });
    }

    const key = 'SessionTypeName';
    const requiredOrder = this.getUniqueList(this.uniquesessiontypelist, key);
    const requiredSessionTypeList = requiredOrder.map(
      (value) => value.SessionTypeName
    );
    this.tempSessionTypeList = this.getUniqueList(
      this.tempSessionTypeList,
      key
    );
    this.sessionTypeList = this.tempSessionTypeList.sort(
      (a, b) =>
        requiredSessionTypeList.indexOf(a[key]) -
        requiredSessionTypeList.indexOf(b[key])
    );
  }
  getUniqueList(array, property) {
    const uniqueList: any = [
      ...new Map(array.map((item) => [item[property], item])).values(),
    ];
    return uniqueList;
  }
  public setSessionStatusCheckboxValue(id: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;
    if (isChecked) {
      this.sessionStatusCheckboxList.push(id);
    } else {
      const index = this.sessionStatusCheckboxList.indexOf(id);
      this.sessionStatusCheckboxList.splice(index, 1);
    }
  }

  getSearchData() {
    this.showLoaderIcon = true;
    if (
      this.isSessionId === true ||
      this.isFacilitator === true ||
      this.isCompName === true ||
      this.isSessCoord === true
    ) {
      this.showLoaderIcon = false;
      console.log(
        "Can't perform Search Action as there is/are validation error"
      );
      return false;
    }

    var SubID = this.selectedSubscriptionId;

    if (
      this.isUserSuperAdmin &&
      this.userRoleID !== 1 &&
      this.userRoleID !== 6 &&
      this.userRoleID !== 3
    ) {
      SubID = '';
    }

    if (
      this.selectedSubscriptionId.trim() ||
      (this.selectedSessionName.trim() && !this.isSessionId) ||
      this.selectedFunction ||
      (this.selectedSessionCoordinator.trim() && !this.isSessCoord) ||
      (this.selectedFacilitator.trim() && !this.isFacilitator) ||
      (this.selectedCompanyName.trim() && !this.isCompName) ||
      this.selectedSponsoringCountry ||
      this.selectedSessionCountry ||
      this.selectedSessionState ||
      this.selectedSessionFormat ||
      this.selectedSessionType ||
      (this.sessionStartDate && this.sessionEndDate) ||
      this.sessionAudienceCheckboxList.length > 0 ||
      this.sessionStatusCheckboxList.length > 0
    ) {
      const inputData = {
        subscriptionID: SubID,
        SessionData: this.selectedSessionName,
        CoordinatorData: this.selectedSessionCoordinator,
        FacilitatorData: this.selectedFacilitator,
        CompanyData: this.selectedCompanyName,
        StartDate: this.sessionStartDate,
        EndDate: this.sessionEndDate,
        ServiceFunctionID: Number(this.selectedFunction),
        CountryID: Number(this.selectedSponsoringCountry),
        LocationID: Number(this.selectedSessionCountry),
        StateID: Number(this.selectedSessionState),
        sessionTypeID: Number(this.selectedSessionType),
        sessionFormatID: Number(this.selectedSessionFormat),
        SessionType: this.sessionAudienceCheckboxList,
        SessionStatus: this.sessionStatusCheckboxList,
        eventTypeId: this.sessionEventSelected,
        eventProgramId: this.sessionProgramSelected,
        ContentAreaID: this.selectedContentArea,
        TopicID: this.selectedTopic,
      };
      this.sessionService
        .getSearchSession(inputData)
        .pipe(takeUntil(this.subscription))
        .subscribe((response) => {
          const res = response.Data;
          if (Array.isArray(res) && res.length > 0) {
            this.showTable = true;
            this.showLoaderIcon = false;
            this.searchAreaFields = false;
            this.seaerchAreaDownArrow = true;
            this.seaerchAreaUpArrow = false;
            this.showLoaderIcon = false;
            this.searchGridHeightSet();
            this.sampleData = res.slice(0, 1000); // To print maximum 1000 records
            this.totalRecords = res.length > 0 ? res[0].TotalRecordsCount : 0;
            this.totalNoRecords = res.length > 0 ? res.length : 0;
            this.isEnableExportBtn = res.length > 0 ? true : false;
            this.setDataOnTabChange();
          } else if (Array.isArray(res) && res.length === 0) {
            this.showTable = true;
            this.showLoaderIcon = false;
            this.searchAreaFields = true;
            this.seaerchAreaDownArrow = false;
            this.seaerchAreaUpArrow = true;
            this.showLoaderIcon = false;
            this.sampleData = res.slice(0, 1000); // To print maximum 1000 records
            this.totalRecords = 0;
            this.totalNoRecords = 0;
            this.isEnableExportBtn = false;
            this.setDataOnTabChange();
          }
        });
    } else {
      this.showLoaderIcon = false;
    }
    this.updateSessionType();
    return true;
  }

  setSessionState(sessionCountryId?) {
    const countryId = this.selectedSessionCountry
      ? this.selectedSessionCountry.toString()
      : sessionCountryId.toString();

    if (countryId != '23') {
      this.selectedSessionState = 0;
    }

    this.sessionStateList = this.dropdownData.States.filter(
      (state) => state.CountryID == countryId
    );
  }

  // for data persist
  setDataOnTabChange() {
    const inputData = {
      subscriptionID: this.selectedSubscriptionId,
      SessionData: this.selectedSessionName,
      CoordinatorData: this.selectedSessionCoordinator,
      FacilitatorData: this.selectedFacilitator,
      CompanyData: this.selectedCompanyName,
      StartDate: this.sessionStartDate,
      EndDate: this.sessionEndDate,
      ServiceFunctionID: Number(this.selectedFunction),
      CountryID: Number(this.selectedSponsoringCountry),
      sLocationID: Number(this.selectedSessionCountry),
      StateID: Number(this.selectedSessionState),
      sessionTypeID: Number(this.selectedSessionType),
      sessionFormatID: Number(this.selectedSessionFormat),
      SessionType: this.sessionAudienceCheckboxList,
      SessionStatus: this.sessionStatusCheckboxList,
      eventTypeId: this.sessionEventSelected,
      eventProgramId: this.sessionProgramSelected,
      SessionTypeList: this.sessionTypeList,
      CountryList: this.sessionCountryList,
      ContentAreaID: Number(this.selectedContentArea),
      TopicID: Number(this.selectedTopic),
    };
    this.masterDataService.sessionSearchModelData = inputData;
  }

  reloadPageWithData(flag?) {
    const sessionSearchData = this.masterDataService.sessionSearchModelData;
    if (sessionSearchData) {
      this.selectedSubscriptionId = sessionSearchData.subscriptionID
        ? sessionSearchData.subscriptionID
        : '';
      this.selectedSessionName = sessionSearchData.SessionData
        ? sessionSearchData.SessionData
        : '';
      this.selectedSessionCoordinator = sessionSearchData.CoordinatorData
        ? sessionSearchData.CoordinatorData
        : '';
      this.selectedFacilitator = sessionSearchData.FacilitatorData
        ? sessionSearchData.FacilitatorData
        : '';
      this.selectedCompanyName = sessionSearchData.CompanyData
        ? sessionSearchData.CompanyData
        : '';
      this.sessionStartDate = sessionSearchData.StartDate
        ? sessionSearchData.StartDate
        : '';
      this.sessionEndDate = sessionSearchData.EndDate
        ? sessionSearchData.EndDate
        : '';
      this.selectedFunction = sessionSearchData.ServiceFunctionID
        ? sessionSearchData.ServiceFunctionID
        : 0;
      this.selectedSponsoringCountry = sessionSearchData.CountryID
        ? sessionSearchData.CountryID
        : null;
      this.selectedSessionCountry = sessionSearchData.sLocationID
        ? sessionSearchData.sLocationID
        : 0;
      this.selectedSessionState = sessionSearchData.StateID
        ? sessionSearchData.StateID
        : 0;
      this.sessionTypeList = sessionSearchData.SessionTypeList
        ? sessionSearchData.SessionTypeList
        : 0;
      this.selectedSessionType = sessionSearchData.sessionTypeID
        ? sessionSearchData.sessionTypeID
        : null;
      this.selectedSessionFormat = sessionSearchData.sessionFormatID
        ? sessionSearchData.sessionFormatID
        : null;
      this.sessionAudienceCheckboxList = sessionSearchData.SessionType
        ? sessionSearchData.SessionType
        : [];
      this.sessionStatusCheckboxList = sessionSearchData.SessionStatus
        ? sessionSearchData.SessionStatus
        : [];
      this.sessionEventSelected = sessionSearchData.eventTypeId
        ? sessionSearchData.eventTypeId
        : null;
      this.sessionCountryList = sessionSearchData.CountryList
        ? sessionSearchData.CountryList
        : [];
      if (
        sessionSearchData.sessionTypeID != null &&
        sessionSearchData.sessionTypeID != 0 &&
        sessionSearchData.eventTypeId != null &&
        sessionSearchData.eventTypeId != 0
      ) {
        this.onSessionEventChange();
      }
      this.selectedContentArea = sessionSearchData.ContentAreaID
        ? sessionSearchData.ContentAreaID
        : 0;
      this.selectedTopic = sessionSearchData.TopicID
        ? sessionSearchData.TopicID
        : 0;
      if (
        (Number(this.selectedSessionType) === 8 ||
          Number(this.selectedSessionType) === 16 ||
          Number(this.selectedSessionType) === 24 ||
          Number(this.selectedSessionType) === 4 ||
          Number(this.selectedSessionType) === 10 ||
          Number(this.selectedSessionType) === 18 ||
          Number(this.selectedSessionType) === 27 ||
          Number(this.selectedSessionType) === 1 ||
          ((Number(this.selectedSessionType) === 11 ||
            Number(this.selectedSessionType) === 19 ||
            Number(this.selectedSessionType) === 26 ||
            Number(this.selectedSessionType) === 2) &&
            (Number(this.sessionEventSelected) === 17 ||
              Number(this.sessionEventSelected) === 18 ||
              Number(this.sessionEventSelected) === 19))) &&
        !this.IsInternalDeloitte
      ) {
        this.disableContentArea = false;
      } else {
        this.disableContentArea = true;
      }
      this.sessionProgramSelected = sessionSearchData.eventProgramId
        ? sessionSearchData.eventProgramId
        : null;

      // Setting the Data
      this.startDate = this.setStartEndDate(this.sessionStartDate);
      this.endDate = this.setStartEndDate(this.sessionEndDate);
      this.onSessionTypeChange();
      this.setSessionAudience(this.sessionAudienceCheckboxList);
      this.setSessionState(this.selectedSessionCountry);
      this.setEventProgram(
        sessionSearchData.eventTypeId,
        sessionSearchData.eventProgramId
      );
      this.setSessionStatus(this.sessionStatusCheckboxList);
      this.onChangeOfInputFields();
      this.validateFields();
      if (flag) {
        this.getSearchData();
      }
    }
  }

  setSessionAudience(checklist) {
    if (checklist && checklist.length > 0) {
      checklist.forEach((id) => {
        if (id === 1) {
          this.IsInternalDeloitte = true;
        } else if (id === 2) {
          this.IsClient = true;
        } else if (id === 3) {
          this.IsNonClient = true;
        } else if (id === 4) {
          this.IsMixedAudience = true;
        }
      });

      setTimeout(() => { }, 200);
    }
  }

  setStartEndDate(inputDate) {
    const tempStartDate = this.ConvertDateToStringFormat(inputDate);

    return new NgbDate(
      Number(tempStartDate.year),
      Number(tempStartDate.month),
      Number(tempStartDate.day)
    );
  }

  ConvertDateToStringFormat(dt) {
    dt = new Date(dt);

    var dateObj = { day: '', month: '', year: 0 };
    var day = ('' + dt.getDate()).slice(-2);
    var month = ('' + (dt.getMonth() + 1)).slice(-2);
    dateObj.day = day;
    dateObj.month = month;
    dateObj.year = dt.getFullYear();
    return dateObj;
  }

  setSessionStatus(checklist) {
    if (checklist && checklist.length > 0) {
      checklist.forEach((id) => {
        if (id === 4) {
          this.IsToReview = true;
        } else if (id === 1) {
          this.IsApproved = true;
        } else if (id === 2) {
          this.IsNotApproved = true;
        } else if (id === 3) {
          this.IsCancelled = true;
        } else if (id === 5) {
          this.IsDraft = true;
        }
      });
    }
  }

  setEventProgram(eventTypeId, eventProgId) {
    if (eventTypeId != null) {
      this.sessionProgramFilterList = this.sessionProgramList.filter(
        (b) => b.eventID === eventTypeId
      );
    }

    if (
      eventProgId != null &&
      this.sessionProgramFilterList &&
      this.sessionProgramFilterList.length > 0
    ) {
      let index = -1;
      index = this.sessionProgramFilterList.findIndex(
        (x) => x.programID === eventProgId
      );
      if (index !== -1) {
        this.sessionProgramSelected =
          this.sessionProgramFilterList[index].programID;
      }
    }
  }

  setColumnHeading() {
    this.allSampleColumns = [
      // DEFAULT COLUMNS (first 7)
      {
        name: 'Sessionstatus',
        header: 'Status',
        dataType: 'string',
        minWidth: '60',
      },
      {
        name: 'SessionName',
        header: 'Session Name',
        dataType: 'string',
        minWidth: '60px',
      },
      {
        name: 'SessionDate',
        header: 'Session Date',
        dataType: 'date',
        minWidth: '60px',
      },
      {
        name: 'Ext',
        header: 'Session Audience',
        dataType: 'string',
        minWidth: '60px',
      },
      {
        name: 'SessionLink',
        header: 'Session Url',
        dataType: 'string',
        minWidth: '30px',
      },
      {
        name: 'AssessmentResults',
        header: 'Assessment Results',
        dataType: 'string',
        minWidth: '30px',
      },
      {
        name: "FeedbackId",
        header: "Feedback Id",
        dataType: "string",
        minWidth: "30px",
      },
      // OPTIONAL COLUMNS (from index 7 onwards)
      { name: 'City', header: 'City', dataType: 'string', minWidth: '60px' },
      {
        name: 'Company',
        header: 'Company/Org',
        dataType: 'string',
        minWidth: '70px',
      },
      {
        name: 'FacilatorId',
        header: 'Facilitator',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'CoordinatorId',
        header: 'Coordinator',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'Deloitte',
        header: 'Deloitte#',
        dataType: 'string',
        minWidth: '60px',
      },
      {
        name: 'ExternalExecutive',
        header: 'Anticipated Participants',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'ActualUsage',
        header: 'Actual Participants',
        dataType: 'string',
        minWidth: '80px',
      },
      // NEW COLUMNS FROM API RESPONSE
      {
        name: 'SponsoringCountryName',
        header: 'Sponsoring Country',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'EventName',
        header: 'Event Id',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'SessionEndDate',
        header: 'Session End Date',
        dataType: 'date',
        minWidth: '80px',
      },
      {
        name: 'SessionCountryName',
        header: 'Session Country',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'SessionTypeName',
        header: 'Session Type',
        dataType: 'string',
        minWidth: '100px',
      },
      {
        name: 'ContentAreaName',
        header: 'Content Area',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'TopicName',
        header: 'Topic',
        dataType: 'string',
        minWidth: '80px',
      },
      {
        name: 'ChargebackWBS',
        header: 'Chargeback WBS',
        dataType: 'string',
        minWidth: '100px',
      },
      {
        name: 'SurchargeWBS',
        header: 'Surcharge WBS',
        dataType: 'string',
        minWidth: '100px',
      },
    ];
    this.resetVisibleColumns();
  }

  resetVisibleColumns() {
    this.selectedAdditionalColumnNames = [];
    this.isColumnSelectorOpen = false;
    this.applyVisibleColumns();
  }

  applyVisibleColumns() {
    const allowedOptionalColumnNames = new Set(
      this.roleFilteredOptionalColumns.map((column) => column.name)
    );

    this.selectedAdditionalColumnNames = this.selectedAdditionalColumnNames.filter(
      (columnName) => allowedOptionalColumnNames.has(columnName)
    );

    const selectedOptionalColumns = this.roleFilteredOptionalColumns.filter((column) =>
      this.selectedAdditionalColumnNames.includes(column.name)
    );
    this.sampleColumns = [...this.defaultColumns, ...selectedOptionalColumns];
  }

  toggleColumnSelector() {
    this.isColumnSelectorOpen = !this.isColumnSelectorOpen;
    this.cdr.detectChanges();
  }

  onDocumentClick(event: MouseEvent) {
    if (this.isColumnSelectorOpen && this.columnPickerContainer) {
      const clickedElement = event.target as HTMLElement;
      const isClickedInsideContainer = this.columnPickerContainer.nativeElement.contains(clickedElement);
      const isClickedOnButton = event.target === document.querySelector('.column-picker-toggle') ||
        (clickedElement.closest('.column-picker-toggle') !== null);
      
      if (!isClickedInsideContainer && !isClickedOnButton) {
        this.isColumnSelectorOpen = false;
      }
    }
  }

  isAdditionalColumnSelected(columnName: string): boolean {
    return this.selectedAdditionalColumnNames.includes(columnName);
  }

  onAdditionalColumnToggle(columnName: string, event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      this.selectedAdditionalColumnNames = [...this.selectedAdditionalColumnNames, columnName];
    } else {
      this.selectedAdditionalColumnNames = this.selectedAdditionalColumnNames.filter(
        (name) => name !== columnName
      );
    }
    this.applyVisibleColumns();
    this.cdr.detectChanges();
  }

  showAllColumns() {
    this.selectedAdditionalColumnNames = this.roleFilteredOptionalColumns.map(
      (column) => column.name
    );
    this.applyVisibleColumns();
    this.cdr.detectChanges();
  }

  get canResetColumnSelection(): boolean {
    return this.selectedAdditionalColumnNames.length > 0;
  }

  get canShowAllColumns(): boolean {
    return this.selectedAdditionalColumnNames.length < this.roleFilteredOptionalColumns.length;
  }

  resetColumnSelection() {
    this.selectedAdditionalColumnNames = [];
    this.applyVisibleColumns();
    this.cdr.detectChanges();
  }

  exportData() {
    this.showLoaderIcon = true;
    if (
      this.selectedSubscriptionId.trim() ||
      (this.selectedSessionName.trim() && !this.isSessionId) ||
      this.selectedFunction ||
      (this.selectedSessionCoordinator.trim() && !this.isSessCoord) ||
      (this.selectedFacilitator.trim() && !this.isFacilitator) ||
      (this.selectedCompanyName.trim() && !this.isCompName) ||
      this.selectedSponsoringCountry ||
      this.selectedSessionCountry ||
      this.selectedSessionState ||
      this.selectedSessionFormat ||
      this.selectedSessionType ||
      this.sessionStartDate ||
      this.sessionEndDate ||
      this.sessionAudienceCheckboxList.length > 0 ||
      this.sessionStatusCheckboxList.length > 0
    ) {
      const inputData = {
        subscriptionID: this.selectedSubscriptionId,
        SessionData: this.selectedSessionName,
        CoordinatorData: this.selectedSessionCoordinator,
        FacilitatorData: this.selectedFacilitator,
        CompanyData: this.selectedCompanyName,
        StartDate: this.sessionStartDate,
        EndDate: this.sessionEndDate,
        ServiceFunctionID: Number(this.selectedFunction),
        CountryID: Number(this.selectedSponsoringCountry),
        LocationID: Number(this.selectedSessionCountry),
        StateID: Number(this.selectedSessionState),
        sessionTypeID: Number(this.selectedSessionType),
        sessionFormatID: Number(this.selectedSessionFormat),
        SessionType: this.sessionAudienceCheckboxList,
        SessionStatus: this.sessionStatusCheckboxList,
        eventTypeId: this.sessionEventSelected,
        eventProgramId: this.sessionProgramSelected,
        ContentAreaID: this.selectedContentArea,
        TopicID: this.selectedTopic,
      };
      this.sessionService.exportReport(inputData).subscribe((res) => {
        var binaryData = [];
        binaryData.push(res);
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/vnd.ms-excel' })
        );
        // create hidden dom element (so it works in all browsers)
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = 'SessionSearchExportReport.xls';
        a.click();
        this.showLoaderIcon = false;
      });
    }
  }

  public showErrorMsgForBothDate: boolean = false;
  public dateErrorMsg: string = '';

  validateDateInputValues(dt) {
    // yyyy-mm-dd
    if (dt != '' && dt != undefined) {
      const reGoodDate =
        /^(?:(19|20)[0-9]{2}[\-.])(0[1-9]|1[012])[\-.](0[1-9]|[12][0-9]|3[01])$/;

      return reGoodDate.test(dt);
    } else {
      return true;
    }
  }

  onFocusOutDate() {
    if (
      (this.sessionStartDate != '' &&
        this.sessionStartDate != undefined &&
        (this.sessionEndDate == '' || this.sessionEndDate == undefined)) ||
      ((this.sessionStartDate == '' || this.sessionStartDate == undefined) &&
        this.sessionEndDate != '' &&
        this.sessionEndDate != undefined)
    ) {
      this.showErrorMsgForBothDate = true;
      this.dateErrorMsg = 'Both dates needed';
      this.IsDateInvalid = false;
      this.invalidDateErrorMsg = '';
      this.enableSearchBtn = false; //disable btn
      this.enableClearBtn = false;
    } else if (
      !this.validateDateInputValues(this.sessionStartDate) ||
      !this.validateDateInputValues(this.sessionEndDate)
    ) {
      this.showErrorMsgForBothDate = true;
      this.dateErrorMsg = 'Please enter valid date';
      this.IsDateInvalid = false;
      this.invalidDateErrorMsg = '';
      this.enableSearchBtn = false; //disable btn
      this.enableClearBtn = false;
    } else {
      this.showErrorMsgForBothDate = false;
      this.dateErrorMsg = '';
    }

    return this.showErrorMsgForBothDate;
  }

  onChangeOfInputFields() {
    if (
      this.selectedSponsoringCountry != null ||
      this.selectedSessionCountry !== 0 ||
      this.selectedSessionState !== 0 ||
      (this.selectedSessionType !== 0 && this.selectedSessionType != null) ||
      (this.selectedFunction !== 0 && this.selectedFunction != null) ||
      (this.selectedSessionFormat !== 0 && this.selectedSessionFormat != null)
    ) {
      this.isAdvanceSearch = true;
    } else {
      this.isAdvanceSearch = false;
    }
    const isDateValidRes = this.onFocusOutDate();
    if (isDateValidRes === false) {
      if (this.sessionStartDate != '' && this.sessionEndDate != '') {
        if (this.sessionStartDate > this.sessionEndDate) {
          this.IsDateInvalid = true;
          this.invalidDateErrorMsg =
            'To Date should be greater than or equal to From Date.';
          this.enableSearchBtn = false;
          this.enableClearBtn = false;
          this.showErrorMsgForBothDate = false;
          this.dateErrorMsg = '';
          this.enableSearchBtn = false; //disable btn
          this.enableClearBtn = false;
        } else {
          this.IsDateInvalid = false;
          this.invalidDateErrorMsg = '';
        }
      }

      if (
        this.selectedSubscriptionId !== '' ||
        this.selectedSessionName !== '' ||
        this.selectedSessionCoordinator !== '' ||
        this.selectedFacilitator !== '' ||
        this.selectedFunction !== 0 ||
        this.selectedCompanyName !== '' ||
        this.IsInternalDeloitte !== false ||
        this.IsClient !== false ||
        this.IsNonClient !== false ||
        this.IsMixedAudience !== false ||
        this.IsCancelled !== false ||
        this.IsToReview !== false ||
        this.IsApproved !== false ||
        this.IsNotApproved !== false ||
        this.IsCancelled !== false ||
        this.IsDraft !== false ||
        this.selectedSponsoringCountry != null ||
        this.selectedSessionCountry !== 0 ||
        this.selectedSessionState !== 0 ||
        (this.selectedSessionType !== 0 && this.selectedSessionType != null) ||
        (this.selectedSessionFormat !== 0 &&
          this.selectedSessionFormat != null) ||
        (this.startDate != undefined &&
          this.startDate.year != null &&
          this.endDate != undefined &&
          this.endDate.year != null &&
          this.showErrorMsgForBothDate != true)
      ) {
        this.enableSearchBtn = true; //btn will be enabled
        this.enableClearBtn = true;
      } else {
        this.enableSearchBtn = false;
        this.enableClearBtn = false;
      }

      if (
        ((this.sessionStartDate == '' || this.sessionStartDate == undefined) &&
          this.sessionEndDate != '' &&
          this.sessionEndDate != undefined) ||
        ((this.sessionEndDate == '' || this.sessionEndDate == undefined) &&
          this.sessionStartDate != '' &&
          this.sessionStartDate != undefined)
      ) {
        this.enableSearchBtn = false;
        this.enableClearBtn = false;
      }
    }
    return false;
  }

  onSessionTypeChange() {
    if (this.selectedSessionType !== 0) {
      var sessionTypeListObj = [];
      this.sessionTypeList.filter((b) => {
        if (
          b.SessionTypeName == 'XA Program/Event' &&
          b.SessionTypeID == Number(this.selectedSessionType)
        )
          sessionTypeListObj.push(b);
      });
      if (sessionTypeListObj.length > 0) {
        if (this.sessionAudienceCheckboxList.length === 0) {
          this.sessionEventFilterList = this.sessionEventList;
        } else {
          const updatedsSessionAudienceCheckboxList = [];
          this.sessionAudienceCheckboxList.forEach(function (value) {
            if (value == 1) {
              updatedsSessionAudienceCheckboxList.push('Deloitte');
            } else if (value == 2) {
              updatedsSessionAudienceCheckboxList.push('ExternalClient');
            } else if (value == 3) {
              updatedsSessionAudienceCheckboxList.push('ExternalNonClient');
            } else if (value == 4) {
              updatedsSessionAudienceCheckboxList.push('MixedAudience');
            } else {
              console.log('');
            }
          });
          const updatedSessionEventList = [];
          for (var i = 0; i < updatedsSessionAudienceCheckboxList.length; i++) {
            this.sessionEventFilterList = this.sessionEventList.filter(
              (b) => b.SessionAudience == updatedsSessionAudienceCheckboxList[i]
            );
            Array.prototype.push.apply(
              updatedSessionEventList,
              this.sessionEventFilterList
            );
          }
          this.sessionEventFilterList = updatedSessionEventList;
        }
        this.sessionEventFilterList = this.sessionEventFilterList.filter(
          (person, index) =>
            index ==
            this.sessionEventFilterList.findIndex(
              (other) => person.Name == other.Name
            )
        );
        this.showEventProgram = true;
      } else {
        this.showEventProgram = false;
        this.onChangeOfEvent();
        this.sessionEventFilterList = [];
        this.sessionEventSelected = null; //0
        this.sessionProgramSelected = null; //0;
      }
    } else {
      this.showEventProgram = false;
      this.onChangeOfEvent();
      this.sessionEventFilterList = [];
      this.sessionEventSelected = null; //0;
      this.sessionProgramSelected = null; // 0;
    }
  }
  onContentChange() {
    this.selectedTopic = 0;
  }
  enableContentArea() {
    this.selectedContentArea = 0;
    this.selectedTopic = 0;
    if (
      (Number(this.selectedSessionType) === 8 ||
        Number(this.selectedSessionType) === 16 ||
        Number(this.selectedSessionType) === 24 ||
        Number(this.selectedSessionType) === 4 ||
        Number(this.selectedSessionType) === 10 ||
        Number(this.selectedSessionType) === 18 ||
        Number(this.selectedSessionType) === 27 ||
        Number(this.selectedSessionType) === 1 ||
        ((Number(this.selectedSessionType) === 11 ||
          Number(this.selectedSessionType) === 19 ||
          Number(this.selectedSessionType) === 26 ||
          Number(this.selectedSessionType) === 2) &&
          (Number(this.sessionEventSelected) === 17 ||
            Number(this.sessionEventSelected) === 18 ||
            Number(this.sessionEventSelected) === 19))) 
    ) {
      this.disableContentArea = false;
    } else {
      this.disableContentArea = true;
    }
  }
  sessioneventobj: any;
  sessioneventobj1: any;
  onSessionEventChange() {
    this.sessioneventobj = this.sessionEventList.filter(
      (b) => b.Name == 'Finance Leadership Program (FLP)'
    );
    this.sessioneventobj1 = this.sessionEventList.filter(
      (b) => b.Name == 'DU Client Experience Team-Led Standard Session'
    );
    // Adding upper if condition to resolve bug: 2108384
    const sessionEventData = this.sessionEventList.filter(
      (b) => b.eventID == this.sessionEventSelected
    );
    if (
      (this.sessioneventobj && this.sessioneventobj.length > 0) ||
      (this.sessioneventobj1 && this.sessioneventobj1.length > 0)
    ) {
      if (
        this.sessionEventSelected != 0 &&
        (sessionEventData[0].Name == this.sessioneventobj[0].Name ||
          sessionEventData[0].Name == this.sessioneventobj1[0].Name)
      ) {
        this.showProgramFinance = false;
      } else {
        this.showProgramFinance = true;
      }
    }
  }
  close() {
    const element = document.querySelector('#collapse1');
    if (element) {
      const myCollapse = new Collapse(element, {
        toggle: true,
      });
    }
  }
  onClearSearch() {
    this.isAdvanceSearch = false;
    this.showErrorMsgForBothDate = false;
    this.dateErrorMsg = '';
    this.totalNoRecords = 0;
    this.searchAreaExpand();
    this.IsDateInvalid = false;
    this.invalidDateErrorMsg = '';
    this.selectedSubscriptionId = '';
    this.selectedSessionName = '';
    this.selectedSessionCoordinator = '';
    this.selectedFacilitator = '';
    this.selectedCompanyName = '';
    this.sessionStartDate = '';
    this.sessionEndDate = '';
    this.selectedFunction = 0;
    this.selectedSponsoringCountry = null;
    this.selectedSessionCountry = 0;
    this.selectedSessionState = 0;
    this.selectedSessionType = null;
    this.selectedSessionFormat = null;
    this.sessionEventSelected = null; //0
    this.sessionProgramSelected = null; //0
    this.sessionAudienceCheckboxList = [];
    this.sessionStatusCheckboxList = [];
    this.IsInternalDeloitte = false;
    this.IsClient = false;
    this.IsNonClient = false;
    this.IsMixedAudience = false;
    this.startDate = '';
    this.endDate = '';
    this.IsToReview = false;
    this.IsApproved = false;
    this.IsNotApproved = false;
    this.IsCancelled = false;
    this.IsDraft = false;
    this.enableSearchBtn = false;
    this.enableClearBtn = false;
    this.showEventProgram = false;
    this.sessionEventFilterList = [];
    this.sessionProgramFilterList = [];
    this.sampleData = []; //empty grid on reset button
    this.showLoaderIcon = false;
    this.showTable = false;
    this.isEnableExportBtn = false;
    this.resetVisibleColumns();
    this.selectedContentArea = 0;
    this.disableContentArea = true;
    this.selectedTopic = 0;
    this.setDataOnTabChange();
    this.sessionErrorMsg = '';
    this.sessCoordErrorMsg = '';
    this.facilitatorErrorMsg = '';
    this.isCompName = false;
    this.compNameErrorMsg = '';
    this.updateSessionType();

    this.sessionCountryList = this.allSessionCountries;
    this.tempSubscriptionId = '';
  }

  validateFields() {
    if (
      this.selectedSessionName.length < 3 &&
      this.selectedSessionName.length > 0
    ) {
      this.isSessionId = true;
      this.sessionErrorMsg =
        'Please enter at least 3 characters to perform search.';
    } else if (
      this.selectedSessionName.length === 0 ||
      this.selectedSessionName.length > 2
    ) {
      this.isSessionId = false;
      this.sessionErrorMsg = '';
    }

    if (
      this.selectedSessionCoordinator.length < 3 &&
      this.selectedSessionCoordinator.length > 0
    ) {
      this.isSessCoord = true;
      this.sessCoordErrorMsg =
        'Please enter at least 3 characters to perform search.';
    } else if (
      this.selectedSessionCoordinator.length === 0 ||
      this.selectedSessionCoordinator.length > 2
    ) {
      this.isSessCoord = false;
      this.sessCoordErrorMsg = '';
    }

    if (
      this.selectedFacilitator.length < 3 &&
      this.selectedFacilitator.length > 0
    ) {
      this.isFacilitator = true;
      this.facilitatorErrorMsg =
        'Please enter at least 3 characters to perform search.';
    } else if (
      this.selectedFacilitator.length === 0 ||
      this.selectedFacilitator.length > 2
    ) {
      this.isFacilitator = false;
      this.facilitatorErrorMsg = '';
    }

    if (
      this.selectedCompanyName.length < 3 &&
      this.selectedCompanyName.length > 0
    ) {
      this.isCompName = true;
      this.compNameErrorMsg =
        'Please enter at least 3 characters to perform search.';
    } else if (
      this.selectedCompanyName.length === 0 ||
      this.selectedCompanyName.length > 2
    ) {
      this.isCompName = false;
      this.compNameErrorMsg = '';
    }
  }

  onRowSelect(rowData) {
    const sessionId = rowData.SessionId ? rowData.SessionId : null;
    if (sessionId) {
      this.router.navigate(['/editSession'], {
        relativeTo: this.activatedRoute,
        queryParams: { id: sessionId },
      });
    }
  }

  onChangeOfEvent() {
    const selectedEventData = this.sessionEventList.filter(
      (b) => b.eventID == this.sessionEventSelected
    );

    if (this.sessionAudienceCheckboxList.length === 1) {
      this.sessionProgramFilterList = this.sessionProgramList.filter(
        (b) => b.eventID == this.sessionEventSelected
      );
    } else if (
      this.sessionAudienceCheckboxList.length === 0 &&
      this.sessionEventSelected
    ) {
      this.sessionProgramFilterList = this.sessionProgramList.filter(
        (b) => b.EventName == selectedEventData[0].Name
      );
    } else {
      const updatedsSessionAudienceCheckboxList = [];
      this.sessionAudienceCheckboxList.forEach(function (value) {
        if (value == 1) {
          updatedsSessionAudienceCheckboxList.push('Deloitte');
        } else if (value == 2) {
          updatedsSessionAudienceCheckboxList.push('ExternalClient');
        } else if (value == 3) {
          updatedsSessionAudienceCheckboxList.push('ExternalNonClient');
        } else if (value == 4) {
          updatedsSessionAudienceCheckboxList.push('MixedAudience');
        } else {
          console.log('');
        }
      });
      const updatedSessionProgramList = [];
      for (var i = 0; i < updatedsSessionAudienceCheckboxList.length; i++) {
        this.sessionProgramFilterList = this.sessionProgramList.filter(
          (b) => b.SessionAudience == updatedsSessionAudienceCheckboxList[i]
        );
        Array.prototype.push.apply(
          updatedSessionProgramList,
          this.sessionProgramFilterList
        );
      }
      this.sessionProgramFilterList = updatedSessionProgramList;
      if (this.sessionEventSelected) {
        this.sessionProgramFilterList = this.sessionProgramFilterList.filter(
          (b) => b.EventName == selectedEventData[0].Name
        );
      }
    }

    this.sessionProgramFilterList = this.sessionProgramFilterList.filter(
      (person, index) =>
        index ==
        this.sessionProgramFilterList.findIndex(
          (other) => person.Name == other.Name
        )
    );
    const temp = this.sessionProgramFilterList.splice(
      this.sessionProgramFilterList.findIndex((res) => res.Name == 'Other'),
      1
    )[0];
    if (temp) this.sessionProgramFilterList.push(temp);
    this.sessionProgramSelected = null; //0;
  }

  onFocusOutCompany(event) {
    this.isCompName =
      event.target.value.length > 2 || event.target.value.length === 0
        ? false
        : true;
    this.selectedCompanyName = event.target.value;
  }

  onFocusOutSessionId(event) {
    this.isSessionId =
      event && event.target.value && event.target.value.trim() ? false : true;
  }

  onFocusOutCoordinator(event) {
    this.isSessCoord =
      event && event.target.value && event.target.value.trim() ? false : true;
  }

  onFocusOutFacilitator(event) {
    this.isFacilitator =
      event && event.target.value && event.target.value.trim() ? false : true;
  }

  ScrollIntoView(elem: string): void {
    setTimeout(() => {
      document
        .querySelector(elem)
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }
}
